import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div style={{position: 'absolute', top: '100px',textAlign:'left', backgroundColor:'white'}}>
      <h1>Privacy Policy</h1>
    <p>Effective date: [Effective Date]</p>

    <h2>Introduction</h2>
    <p>We ("we", "our", "us") are committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by our iOS applications.</p>

    <h2>Information We Collect</h2>
    <h3>Personal Information</h3>
    <p>We collect personal information that you provide to us directly when you use our applications. This includes:</p>
    <ul>
        <li><strong>Account Information</strong>: If you create an account, we may collect your name, email address, and password.</li>
        <li><strong>Usage Data</strong>: Information regarding your interactions with our applications, such as preferences and settings.</li>
    </ul>

    <h3>Usage Information</h3>
    <p>We collect information about your interactions with the application, including:</p>
    <ul>
        <li><strong>Device Information</strong>: Information about the device you use to access the application, including device model, operating system, and unique device identifiers.</li>
        <li><strong>Log Data</strong>: Information about your use of the application, including access times, pages viewed, and your IP address.</li>
    </ul>

    <h2>How We Use Your Information</h2>
    <p>We use your personal information for the following purposes:</p>
    <ul>
        <li><strong>To Provide and Maintain Our Service</strong>: To operate and provide the features and functionality of the application.</li>
        <li><strong>To Improve Our Service</strong>: To understand and analyze how you use the application and develop new features and services.</li>
        <li><strong>To Communicate with You</strong>: To send you updates, notifications, and other information related to the application.</li>
    </ul>

    <h2>How We Share Your Information</h2>
    <p>We do not share your personal information with third parties except in the following circumstances:</p>
    <ul>
        <li><strong>With Your Consent</strong>: We may share your information if you give us specific permission to do so.</li>
        <li><strong>For Legal Reasons</strong>: We may disclose your information if required by law or to protect the rights and safety of our users and others.</li>
    </ul>

    <h2>Data Security</h2>
    <p>We implement reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no internet or email transmission is ever fully secure or error-free, so please take special care in deciding what information you send to us.</p>

    <h2>Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
        <li><strong>Access</strong>: Request access to the personal information we hold about you.</li>
        <li><strong>Correction</strong>: Request correction of any inaccurate or incomplete personal information.</li>
        <li><strong>Deletion</strong>: Request deletion of your personal information.</li>
    </ul>

    <h2>Changes to This Privacy Policy</h2>
    <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>

    <h2>Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
    <p>Email: mehmetalicelebii@gmail.com</p>
      </div>
  );
};

export default PrivacyPolicyPage;
